import { useCallback, useEffect, useMemo, useReducer, useState } from 'react';
import img1 from '../../../../assets/t-304/dzungla1.jpg';
import img2 from '../../../../assets/t-304/londyn.jpg';
import img3 from '../../../../assets/t-304/pacanoow.jpg';
import img4 from '../../../../assets/t-304/smalandia_szwecja.jpg';
import img5 from '../../../../assets/t-304/szkocja.jpg';
import img6 from '../../../../assets/t-304/wyspa_sw_edwarda_kanada.jpg';
//@ts-ignore
import { Preview } from 'react-dnd-preview'
import './style.scss';
import PickUp from '../../../drag-drop-template/pick-up';
import DropZone from '../../../drag-drop-template/drop-zone';
import classNames from 'classnames';

type Props = {
    onComplete(): void
}

const DATA = [
    [img1, 'Mowgli'],
    [img2, 'Mary Poppins'],
    [img3, 'Koziołek Matołek'],
    [img4, 'Emil ze Smalandii'],
    [img5, 'Lassie '],
    [img6, 'Ania z Zielonego Wzgórza']
];

type Book = {
    id: string,
    title: string
}

type Image = {
    id: string,
    src: string,
    correct: string,
    book?: Book
}

type GameState = {
    books: Book[],
    images: Image[]
}


const Task304Game: React.FC<Props> = ({ onComplete }) => {

    const [gameState, moveBook] = useReducer((state: GameState, { type, bId, iId }: { type: 'move' | 'next', bId?: string, iId?: string }) => {

        if (type === 'move') {
            const book = state.books.find(image => image.id === bId);

            if (book) {
                return {
                    images: state.images.map(image => {
                        if (image.id === iId) {
                            return {
                                ...image,
                                book
                            }
                        }
                        return image;
                    }),
                    books: state.books.filter(book => book.id !== bId),
                }
            }
        }


        if (type === 'next') {
            return {
                ...state,
                images: state.images.filter(image => image.id !== iId),
            }
        }

        return state;
    }, {
        books: DATA.map(([src, title], index) => {
            return {
                id: `b${index}`,
                title
            }
        }).sort(_ => Math.random() - .5),
        images: DATA.map(([src, title], index) => {
            return {
                id: `i${index}`,
                correct: `b${index}`,
                src
            }
        })
    })

    const image = useMemo(() => {
        return gameState.images[0]
    }, [gameState]);

    const [error, setError] = useState(false);
    const [correct, setCorrect] = useState(false);

    useEffect(() => {
        if (error) {
            const id = setTimeout(() => {
                setError(false);
            }, 1000);

            return () => {
                clearTimeout(id)
            }
        }

    }, [error, setError]);

    useEffect(() => {
        if (correct) {
            const id = setTimeout(() => {
                setCorrect(false);
                moveBook({
                    type: 'next',
                    iId: image.id
                })
            }, 1000);

            return () => {
                clearTimeout(id)
            }
        }

    }, [correct, image, setCorrect]);

    const onDrop = useCallback((pickupId: string, dropId: string) => {
        const book = gameState.books.find(q => q.id === pickupId);
        const image = gameState.images.find(i => i.id === dropId);

        if (book && image && image.correct === book.id) {
            setCorrect(true);
            moveBook({
                type: 'move',
                bId: pickupId,
                iId: dropId
            })
        } else {
            setError(true);
        }

    }, [moveBook, gameState, setError]);

    const imageClassNames = classNames('image', {
        error,
        correct
    })

    const gameEnd = useMemo(() => !Boolean(gameState.books.length && image), [gameState, image]);

    useEffect(() => {
        if (gameEnd) {
            onComplete();
        }
    }, [gameEnd, onComplete])

    return <div className="task-304-game">
        {!gameEnd && <>
            <div className="books">
                {
                    gameState.books.map((book) => {
                        return <PickUp key={book.id} data={{
                            type: 'item',
                            id: book.id,
                            data: book
                        }}>
                            <GameItem item={book} />
                        </PickUp>
                    })
                }
            </div>
            <div className="images">
                {image && <div className={imageClassNames}>
                    <div className="img-container">
                        <img src={image.src} alt="" />
                    </div>
                    <div className="image-book-container">
                        {!image.book && <DropZone id={image.id} targetType="item" onDrop={onDrop}>
                            Przenieś odpowiednią książkę tutaj
                        </DropZone>}
                        {image.book && <GameItem item={image.book} />}
                    </div>
                </div>}
            </div>
        </>}
        {gameEnd && <div className="end-game">
            <p>Udało Wam się dopasować wszystkich bohaterów!</p>
        </div>
        }

        <ItemPreview />
    </div>
}

const GameItem: React.FC<{ item: Book }> = ({ item: data }) => {
    return <div className="book-item task-304-pick-up">
        <div className="inner" dangerouslySetInnerHTML={{ __html: data.title }}></div>
    </div>
}

const ItemPreview: React.FC<{}> = () => {
    return <Preview>{({ item, style }: any) => {
        return <div style={{ ...style, width: item.size.width }}>
            <GameItem item={item.data} />
        </div>
    }}</Preview>
}

export default Task304Game;
